import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { Translate, TextFormat, getSortState } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { ASC, DESC, SORT } from 'app/shared/util/pagination.constants';
import { overrideSortStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities } from './custom-occurence.reducer';

export const CustomOccurence = () => {
  const dispatch = useAppDispatch();

  const location = useLocation();
  const navigate = useNavigate();

  const [sortState, setSortState] = useState(overrideSortStateWithQueryParams(getSortState(location, 'id'), location.search));

  const customOccurenceList = useAppSelector(state => state.customOccurence.entities);
  const loading = useAppSelector(state => state.customOccurence.loading);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        sort: `${sortState.sort},${sortState.order}`,
      })
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?sort=${sortState.sort},${sortState.order}`;
    if (location.search !== endURL) {
      navigate(`${location.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [sortState.order, sortState.sort]);

  const sort = p => () => {
    setSortState({
      ...sortState,
      order: sortState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = sortState.sort;
    const order = sortState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    } else {
      return order === ASC ? faSortUp : faSortDown;
    }
  };

  return (
    <div>
      <h2 id="custom-occurence-heading" data-cy="CustomOccurenceHeading">
        <Translate contentKey="reachamyApp.customOccurence.home.title">Custom Occurences</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="reachamyApp.customOccurence.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/custom-occurence/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="reachamyApp.customOccurence.home.createLabel">Create new Custom Occurence</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {customOccurenceList && customOccurenceList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="reachamyApp.customOccurence.id">ID</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('activityNumber')}>
                  <Translate contentKey="reachamyApp.customOccurence.activityNumber">Activity Number</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('activityNumber')} />
                </th>
                <th className="hand" onClick={sort('repeatEveryNth')}>
                  <Translate contentKey="reachamyApp.customOccurence.repeatEveryNth">Repeat Every Nth</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('repeatEveryNth')} />
                </th>
                <th className="hand" onClick={sort('weekORMonthORYear')}>
                  <Translate contentKey="reachamyApp.customOccurence.weekORMonthORYear">Week OR Month OR Year</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('weekORMonthORYear')} />
                </th>
                <th className="hand" onClick={sort('occurence')}>
                  <Translate contentKey="reachamyApp.customOccurence.occurence">Occurence</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('occurence')} />
                </th>
                <th className="hand" onClick={sort('endDate')}>
                  <Translate contentKey="reachamyApp.customOccurence.endDate">End Date</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('endDate')} />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {customOccurenceList.map((customOccurence, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/custom-occurence/${customOccurence.id}`} color="link" size="sm">
                      {customOccurence.id}
                    </Button>
                  </td>
                  <td>{customOccurence.activityNumber}</td>
                  <td>{customOccurence.repeatEveryNth}</td>
                  <td>
                    <Translate contentKey={`reachamyApp.WMY.${customOccurence.weekORMonthORYear}`} />
                  </td>
                  <td>{customOccurence.occurence}</td>
                  <td>
                    {customOccurence.endDate ? (
                      <TextFormat type="date" value={customOccurence.endDate} format={APP_LOCAL_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/custom-occurence/${customOccurence.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/custom-occurence/${customOccurence.id}/edit`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/custom-occurence/${customOccurence.id}/delete`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="reachamyApp.customOccurence.home.notFound">No Custom Occurences found</Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default CustomOccurence;
